"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChipIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var _index = require("../../styles/index.js");
var IconSpacer = _styledComponents["default"].span.withConfig({
  displayName: "Icon__IconSpacer",
  componentId: "sc-1hpzz1n-0"
})(["", ";padding:", ";display:inline-flex;"], (0, _index.rootStyle)(), (0, _index.cssSpacing)('tighter-4', '4px'));
var ChipIcon = exports.ChipIcon = function ChipIcon(_ref) {
  var icon = _ref.icon,
    size = _ref.size;
  var Icon = icon;
  return /*#__PURE__*/_react["default"].createElement(IconSpacer, null, /*#__PURE__*/_react["default"].createElement(Icon, {
    size: size
  }));
};